import { Field } from 'formik';
import { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormStepHeader } from '../../../../../components/forms';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useToast } from '../../../../../context/ToastContext';
import { useGetCoursesQuery } from '../../../../../services/endpoints/schedule/course';
import { StepProps } from './AddEditRegistration';

export const RegistrationsForm = ({ touched, errors, values, setFieldValue }: StepProps) => {
  const { data, error, isLoading } = useGetCoursesQuery({
    scope: 'upcoming',
    omitScopeCount: true,
    data: {
      entries: 10000,
      orderBy: { field: 'title', order: 'asc' },
      filterBy: [{ field: 'payment_type', operator: 'equals', value: 'website' }]
    }
  });
  const { addToast } = useToast();

  useEffect(() => {
    if (error && !isLoading) {
      addToast('Error while loading courses', 'error');
    }
  }, [data, error, isLoading]);

  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Registrations" />
      </Col>
      <Col xs={12}>
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="course_id"
        >
          <Field
            as={FormSelect}
            name="course_id"
            label="Upcoming Session"
            required
            options={
              data?.results?.map((course: { id: number; title: string }) => ({
                value: course.id,
                label: course.title
              })) ?? []
            }
            loadingError={error ? 'Error loading sessions' : undefined}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};
